import React, { useContext, useImperativeHandle, useState, useMemo, useRef, useEffect, createRef } from 'react';
import { Button, Modal, message, Tabs } from 'antd';
import type { SpComListType } from '../../index';
import SelectTree from './components/SelectTree';
import styles from './index.module.less';
import getShowTreeDataFromApiName from './service';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { getAutoCode, getModuleRecordList } from '@/common/asset-apis/assetModel';
import { Api } from '@cui/req';
import { filterTableSchema } from './consts';
import { cloneDeep } from 'lodash';
import { postRecordList } from '@/api/npi.api';
import { batchUpdate, batchCreate, deleteAssetRecord } from '@/common/asset-apis/assetModel';
import { COLUMN_FROM } from '@/components/SEFieldWithModel/effects/consts';

const FilterTree: React.FC<SpComListType> = function FilterTree(props) {
  const { choosenCode, setFilterDisplay, formProductSort, formBrandType, formBrand, field, customCode, onlyCode, setOptionList, onChange, linkShowModalContrulor, nodeType, config, columnFrom, setRowData } = props;
  const { emitEvent } = config?.metaStore || {};
  // 树图数据
  const [showTreeData, setShowTreeData] = useState<any>();
  const [showTreeList, setShowTreeList] = useState<any>([]);
  // 树图选中
  const [activeKey, setActiveKey] = useState<string>();
  const [allListData, setAllListData] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterMap, setFilterMap] = useState<any>({});
  const [lineId, setLineId] = useState<string>('');
  const [materialNumber, setMaterialNumber] = useState<string>('');
  const [cpartCode, setCpartCode] = useState<string>('');
  const [allDataMap, setAllDataMap] = useState<any>({});
  const [deleteData, setDeleteData] = useState<any>([]);

  const tableRef: any = {};
  filterTableSchema.forEach((item: any) => {
    tableRef[item.moduleID] = createRef<any>();
  });

  const getShowTreeDataFromApi = async (data: any) => {
    const resData = await getShowTreeDataFromApiName(data, 'getShowTreeFromCpartData');
    if (resData.treeData) {
      setFilterDisplay(false);
    }
    setShowTreeData(resData.treeData);
    setShowTreeList(resData.treeList);
  };

  // useEffect(() => {
  //   if (choosenCode) {
  //     const bd_bpart_product_classification_number = nodeType === 'sale' ? choosenCode.bd_bpart_product_classification_number : choosenCode.bd_bpart_product_classification_number;
  //     const bd_brand_classification_type_code = nodeType === 'sale' ? choosenCode.bd_brand_classification_type_code : choosenCode.bd_brand_classification_type_code;
  //     const bd_brand_classification_number = nodeType === 'sale' ? choosenCode.product_brand : choosenCode.bd_brand_classification_number;
  //     getShowTreeDataFromApi({
  //       bd_bpart_product_classification_number,
  //       bd_brand_classification_type_code: bd_brand_classification_type_code || '',
  //       bd_brand_classification_number: bd_brand_classification_number || '',
  //       // bd_bpart_product_classification_number: choosenCode.slave_of_spu,
  //       // bd_brand_classification_type_code: choosenCode.bd_brand_classification_type_code,
  //       // bd_brand_classification_number: choosenCode.product_brand,
  //       // bd_bpart_product_classification_number: formProductSort,
  //       // bd_brand_classification_type_code: formBrandType,
  //       // bd_brand_classification_number: formBrand,
  //     });
  //   }
  // }, [choosenCode]);

  const getFeatureList = () => {
    const params = {
      moduleID: 'md_cpart_product_feature_info',
      namespaceID: 'master_data',
      filter: `md_bbom_template_line_id = '${lineId}' AND product_code = '${cpartCode}'`,
    };
    getModuleRecordList(Api, 'master_data', 'md_cpart_product_feature_info', params).then((res: any) => {
      if (res?.set?.length < 1) {
        getDefualtValues(showTreeList, showTreeData?.id);
      }
    });
  };

  const getDefualtValues = async (treeList: any[], bpartType: string) => {
    const allType = await getAllType();
    const list: any[] = [];
    treeList?.map((el: any) => {
      const typeList = el.bd_feature_type_number;
      return {
        ...el,
        bd_feature_type_number: !Array.isArray(typeList) ? typeList?.split(',') : typeList,
      };
    }).forEach((el: any) => {
      el.bd_feature_type_number?.forEach((type: string) => {
        allType[type]?.forEach((item: any) => {
          if (item.product_type === el.product_type && item.feature_type === type) {
            const newItem: any = {
              // 产品编码
              product_code: cpartCode,
              // 结构部件
              bd_material_classification_number: el.bd_material_classification_number,
              // 部件id
              md_bbom_template_line_id: el.md_bbom_template_line_id,
              // 特征参数类型
              bd_feature_type_classification_number: type,
              // 特征参数
              feature_code: item.number,
              // 产品或物料品类
              product_type: item.product_type,
            };
            list.push(newItem);
          }
        });
      });
    });
    const lineList = list.filter(item => item.md_bbom_template_line_id === lineId);
    tableRef.md_cpart_product_feature_info.current.addEditRecord(lineList);
  };

  const getAllType = async () => {
    const listRes = await postRecordList({
      app_id: 'base',
      model_id: 'bd_feature',
    });
    const typeMap: any = {};
    const types = listRes.data?.map((el: any) => el.feature_type).filter((el: string, ind: number, arr: string[]) => arr.indexOf(el) === ind);
    types.forEach((el: string) => {
      const list = listRes.data?.filter((item: any) => item.feature_type === el);
      typeMap[el] = list;
    });
    return typeMap;
  };

  const onSelectNodeChange = async (data: any) => {
    // 客户产品获取产品编码
    let autoCode = '';
    if (nodeType === 'sale') {
      const params = {
        moduleID: 'md_cpart_product_base_info',
        namespaceID: 'master_data',
        filter: `spu = '${choosenCode.code}' AND cus_org_code = '${customCode}' AND ${field?.bizConfig?.onlyCodeType} = '${onlyCode}'`,
      };
      const result = await getModuleRecordList(Api, 'master_data', 'md_cpart_product_base_info', params);
      if (result?.set?.length > 0) {
        autoCode = result.set[0]?.values.find((v: any) => v.name === 'product_code')?.value;
      } else {
        const res = await getAutoCode(Api, { prefix: 'CP' });
        autoCode = res[1]?.data?.data;
      }
    } else {
      autoCode = choosenCode.code;
    }
    setCpartCode(autoCode);
    setFilterMap({
      md_cpart_product_feature_info: `md_bbom_template_line_id = '${data.md_bbom_template_line_id}' AND product_code = '${autoCode}'`,
      cpart_feature_attachments: `md_bbom_template_line_id = '${data.md_bbom_template_line_id}' AND cpart_number = '${autoCode}'`,
      cpart_main_material: `md_bbom_template_line_id = '${data.md_bbom_template_line_id}' AND cpart_number = '${autoCode}'`,
      md_cpart_bom: `md_bbom_template_line_id = '${data.md_bbom_template_line_id}' AND md_cpart_product_base_info_product_code = '${autoCode}'`,
    });
    setLineId(data.md_bbom_template_line_id);
    setMaterialNumber(data.bd_material_classification_number);
    setIsModalOpen(true);
    // setActiveKey(data && data[freeComponentsConfig?.treeRelationField]);
  };

  const addRecord = (moduleID: string) => {
    let data: any = {};
    if (moduleID === 'md_cpart_product_feature_info') {
      data = {
        md_bbom_template_line_id: lineId,
        product_code: cpartCode,
      };
    } else if (moduleID === 'md_cpart_bom') {
      if (tableRef[moduleID].current.getRowsData()?.length > 0) {
        message.warning('部件需求只能新增一条');
        return;
      }
      data = {
        md_bbom_template_line_id: lineId,
        md_cpart_product_base_info_product_code: cpartCode,
        bd_material_classification_number: materialNumber,
      };
    } else {
      data = {
        md_bbom_template_line_id: lineId,
        cpart_number: cpartCode,
        bd_material_classification_number: materialNumber,
      };
    }
    tableRef[moduleID].current.addEditRecord(data);
  };

  const deleteRecord = (moduleID: string, record: any, index: number) => {
    if (record?.created_at) {
      const newData = cloneDeep(deleteData);
      newData.push({
        moduleID,
        // id: record?.RECORD?.recordID,
        id: record?._id,
      });
      setDeleteData(newData);
    }
    tableRef[moduleID].current.editableRef.current.removeRow(index);
  };

  const tableChange = (rowsData: any, module: any) => {
    const newData = cloneDeep(allDataMap);
    const cloneRow = cloneDeep(rowsData);
    cloneRow.forEach((item: any) => {
      delete item.toJSON;
      delete item.RECORD;
      delete item._id;
    });
    newData[module.moduleID] = cloneRow;
    setAllDataMap(newData);
  };

  const saveData = async () => {
    if (nodeType === 'sale') {
      const params = {
        moduleID: 'md_cpart_product_base_info',
        namespaceID: 'master_data',
        filter: `product_code = '${cpartCode}'`,
      };
      const result = await getModuleRecordList(Api, 'master_data', 'md_cpart_product_base_info', params);
      if (result?.set?.length < 1) {
        // 客户产品基本信息保存
        const caprtInfo: Record<any, any> = {};
        caprtInfo.product_code = cpartCode; // 客户产品编码
        caprtInfo.product_name = choosenCode.name; // 客户产品名称
        caprtInfo.spu = choosenCode.code; // 销售产品
        caprtInfo.product_type = choosenCode.product_type; // 产品品类
        caprtInfo.bd_bpart_product_classification_number = choosenCode.bd_bpart_product_classification_number; // 设计分类
        caprtInfo.bd_brand_classification_type_code = choosenCode.bd_brand_classification_type_code; // 品牌类型
        caprtInfo.bd_brand_classification_number = choosenCode.product_brand; // 品牌
        caprtInfo.audit_status = '03';
        caprtInfo.managerial_status = '02';
        caprtInfo.product_desc = choosenCode.desc;
        caprtInfo.sale_basic_price = choosenCode.sale_basic_price;
        caprtInfo.unit_code = choosenCode.unit_code;
        caprtInfo.product_model = choosenCode.product_model;
        caprtInfo.cus_org_code = customCode; // 客户经营组织编码
        caprtInfo[field?.bizConfig?.onlyCodeType] = onlyCode; // 唯一编号
        const cpartParams = {
          namespaceID: 'master_data',
          moduleID: 'md_cpart_product_base_info',
          parameterList: [caprtInfo],
        };
        await batchCreate(Api, cpartParams);
      }
    }
    // 客户结构保存
    const reqList: any[] = [];
    Object.keys(allDataMap).forEach((key: string) => {
      if (allDataMap[key]?.length > 0) {
        const addList: any = [];
        const updateList: any = [];
        allDataMap[key].forEach((item: any) => {
          if (item.created_at) {
            updateList.push(item);
          } else {
            addList.push(item);
          }
        });
        if (updateList.length > 0) {
          const params = {
            namespaceID: 'master_data',
            moduleID: key,
            parameterList: updateList,
          };
          const p = new Promise((resolve) => {
            resolve(batchUpdate(Api, params));
          });
          reqList.push(p);
        }
        if (addList.length > 0) {
          const params = {
            namespaceID: 'master_data',
            moduleID: key,
            parameterList: addList,
          };
          const p = new Promise((resolve) => {
            resolve(batchCreate(Api, params));
          });
          reqList.push(p);
        }
      }
    });
    // 调后端删除接口
    deleteData?.forEach((item: any) => {
      if (item.moduleID && item.id) {
        deleteAssetRecord(Api, {
          namespaceID: 'master_data',
          moduleID: item.moduleID,
          id: item.id,
        });
      }
    });
    Promise.all(reqList).then(() => {
      setIsModalOpen(false);
      setOptionList([{
        name: choosenCode.name,
        code: cpartCode,
      }]);
      if (columnFrom === COLUMN_FROM.TABLE && field?.bizConfig?.spartCode) {
        setRowData(config.rowIndex, {
          [field.name]: cpartCode,
          [field?.bizConfig?.spartCode]: choosenCode.code,
        });
      } else {
        onChange && onChange(cpartCode);
      }
      // linkShowModalContrulor(false);
    });
  };

  return (
    <div className={styles.line_box}>
      {showTreeData && <SelectTree
        showTreeData={showTreeData}
        onSelectNodeChange={onSelectNodeChange}
      />}
      {isModalOpen &&
        <Modal
          title="编辑"
          visible
          onCancel={() => setIsModalOpen(false)}
          width="70vw"
          okText="保存"
          cancelText="取消"
          onOk={saveData}
          destroyOnClose
          maskClosable={false}
        >
          <Tabs onChange={(key) => {
            if (key === 'md_cpart_product_feature_info' && tableRef.md_cpart_product_feature_info.current.getRowsData().length < 1) {
              getFeatureList();
            }
          }}>
            {filterTableSchema.map((module: any, i) => {
              return (
                <Tabs.TabPane tab={module?.title} key={module?.moduleID} forceRender>
                  <AssetModuleTable
                    ref={tableRef[module.moduleID]}
                    key={module.moduleID}
                    headerTitle="none"
                    search={false}
                    onChange={(rowsData: any) => {
                      tableChange(rowsData, module);
                    }}
                    API={{
                      FetchAPI: Api,
                    }}
                    // rowKey={fieldName}
                    moduleID={module.moduleID}
                    namespaceID={module.namespaceID}
                    filter={filterMap[module.moduleID]}
                    columns={module.columns}
                    tableBaseMode="edit"
                    rowDelable={false}
                    toolBarRender={
                      module.moduleID !== 'md_cpart_product_feature_info' ?
                        [
                          <>
                            <Button type="primary" ghost onClick={() => addRecord(module.moduleID)}>
                              新增
                            </Button>
                          </>,
                        ] : []
                    }
                    optionColumns={
                      module.moduleID !== 'md_cpart_product_feature_info' ?
                        {
                          title: '操作',
                          valueType: 'option',
                          dataIndex: 'options',
                          fixed: 'right',
                          width: 140,
                          align: 'center',
                          render: (_text: any, record: any, index: number) => {
                            return (
                              <span>
                                <Button
                                  type="link"
                                  onClick={() => deleteRecord(module.moduleID, record, index)}
                                >
                                  删除
                                </Button>
                              </span>
                            );
                          },
                        } : false
                    }
                  />
                </Tabs.TabPane>
              );
            })}
          </Tabs>
        </Modal>
      }
    </div>
  );
};

export default FilterTree;
